import * as React from 'react'
import { observer } from 'mobx-react'
import AdminBundleManagerViewModel from 'admin/bundle/BundleManagerViewModel'
import BundleManagerCardContainer from '../BundleManagerCardContainer'

interface BundleManagerContentProps {
  vm: AdminBundleManagerViewModel
}

export default observer(function BundleManagerContent({
  vm,
}: BundleManagerContentProps) {
  return (
    <>
      {vm.workspaces.map((workspace) => {
        const workspaceBundleVM = vm.getWorkspaceBundleVM(workspace)
        if (!workspaceBundleVM) {
          return null
        }
        return (
          <BundleManagerCardContainer
            vm={workspaceBundleVM!}
            workspace={workspace}
            key={workspace.id}
          />
        )
      })}
    </>
  )
})
